// @owners { team: patients-team }
import React, { useEffect } from 'react';
// eslint-disable-next-line import/no-deprecated
import { type OnboardingUserUpdate, updateOnboardingUser } from '~shared/actions/onboarding';
import { setEditingInsuranceID } from '~shared/actions/onboarding';
import { ONBOARD_STATE_INSURANCE_FOUND } from '~shared/features/onboarding/helpers/onboardingRouteHandler';
import { routeFromPath } from '~shared/features/onboarding/helpers/routeToPath';
import getShowProgynySelfServiceForUser from '~shared/features/users/selectors/getShowProgynySelfServiceForUser';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import { useNavigationContext } from '~web/contexts';
import { OnboardingInsuranceFoundPage } from '~web/features/onboarding/components/redesign/OnboardingInsuranceFoundPage';

type Props = {
  // eslint-disable-next-line import/no-deprecated
  readonly updateOnboardingUser: (update: OnboardingUserUpdate) => Promise<boolean>;
  readonly showProgyny: boolean;
};

const OnboardingInsuranceFoundContainer = ({ showProgyny, updateOnboardingUser }: Props) => {
  const { trackPageView } = useAnalytics();
  const { previous: previousUrl } = useNavigationContext();

  useEffect(() => {
    updateOnboardingUser({
      onboard_state: ONBOARD_STATE_INSURANCE_FOUND,
    });

    trackPageView({
      event: EVENTS.ONBOARDING__INSURANCE_FOUND_VIEWED,
      params: { origin: previousUrl ? routeFromPath(previousUrl) : '', is_progyny_rx_view: showProgyny },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <OnboardingInsuranceFoundPage />;
};

const mapStateToProps = (state: ReduxStateShared) => {
  return {
    showProgyny: getShowProgynySelfServiceForUser(state),
  };
};

const mapDispatchToProps = {
  // eslint-disable-next-line import/no-deprecated
  updateOnboardingUser,
  setEditingInsuranceID,
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingInsuranceFoundContainer);
